const getters = {
  // 昵称
  nickName: (state) => state.user.nickName,
  // 头像
  headPortrait: (state) => state.user.headPortrait,
  mobile: (state) => state.user.mobile,
  // 我的套餐
  packageInfo: (state) => state.wallet.packageInfo,
  // 个人中心展示的套餐
  userValidOrderInfo: (state) => state.wallet.userValidOrderInfo,
  keepAlive: (state) => state.keepAlive.keepAlive,
};
export default getters;
